import { getData } from "../firebase/firestore/getData";

export const getCredentials = (successCb) => {
  // get crednetials from firebase

  getData(
    "users/hiL2J6NqZOUlSuqxR5CuHupUkse2",
    (data) => {
      let email = data.toggl.email;
      let password = data.toggl.password;
      successCb(btoa(email + ":" + password));
    },
    (error) => {
      console.log(error);
    }
  );
};

export const getWorkspaceId = () => {
  return "7275671";
};
